
(function () {
  'use strict';

  class CalendarControlComponent extends Controllers.BaseControllerES6 {

    // @ngInject
    constructor($scope, $injector) {
      super($scope, $injector);
      this.__objectType = 'CalendarControlComponent';
    }
  }

  Components.CalendarControl = {
    bindings: {
      title: '=',
      handleChange: '&',
      analytics: '@'
    },
    controller: CalendarControlComponent,
    name : 'hbCalendarControl',
    templateUrl: 'angular/app/modules/core/features/calendar/calendar_control/calendar_control.html',
  };

}());
